import noimage from "./Assets/no data.png";
const EnvName = "stage";
var key = {};
key.KEY = "CardBo@rD1290%6Fine3";
key.ENCODEKEY = "gallfi@mArt!game";
key.EnvName = EnvName;
key.ONEDAYINSECONDS = 0;
key.BLOCKS_PER_YEAR = 0;
key.NOIMAGE = noimage;
key.ClI_ID = "42b342577b8de3ce7128280cb30a529a";
key.RPAD_ADDRESS = "";
key.ROUTER = "";
key.EMAIL = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
key.MOBILE = /^\d{10}$/;
key.NumOnly = /^\d+$/;
key.PASSWORD =
  /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{8,15}$/;
key.OnlyAlbhabets = /^(?:[A-Za-z]+)(?:[A-Za-z0-9 _]*)$/;
key.notSpecil = /^[a-zA-Z-9]+$/;
key.OnlyAlphSpecial = /^[A-usZa-z_@.#&+-]*$/;
key.IPFS = "https://ipfs.io/ipfs/";
key.limit = 50;
key.NumDigitOnly = /[^0-9\.]/g;
key.NumberOnly = /[^0-9]/g;
//  key.IMG_URL = "https://dmywb5hxgl1qh.cloudfront.net/"
key.IMG_URL = "https://d2y7h9ktdedpcy.cloudfront.net/";
key.IMG_URL_ = "https://d2y7h9ktdedpcy.cloudfront.net";

key.TOKEN = ["galfi", "usdt"];

const DEMO_COLLECTION_CONTRACT_DETAILS = {
  ship: {
    displayName: "Galfi Ship",
    address: "0x71411d7fee6941a8cb051985eda43262616faa2e",
    symbol: "GALFISHIP",
    handle: "SHIP",
    type: "ship",
    collectionID: "667e91c21ea449904060390a",
  },
  planet: {
    displayName: "Galfi Planet",
    address: "0x5e6f4ba923921bcafbebb8d15dff35952c7d1811",
    symbol: "GALFIPLANET",
    handle: "PLANET",
    type: "planet",
  },
  specialcrew: {
    displayName: "Galfi Special Crew",
    address: "0xf1bf05ffdefd578518647109e2f40080d384d829",
    symbol: "GALFISPECIALCREW",
    handle: "SPECIALCREW",
    type: "crew",
  },
  astroid: {
    displayName: "Galfi Asteroid",
    address: "0x793308709e833317f8fc3489e85c86e20db46067",
    symbol: "GALFIASTROID",
    handle: "ASTROID",
    type: "astroid",
  },
  crew: {
    displayName: "Galfi Crew",
    address: "0xe4c26a714d72592c6eb307296dbdf0c411f3ee30",
    symbol: "GALFICREW",
    handle: "CREW",
    type: "crew",
  },
};
const PRODUCTION_COLLECTION_CONTRACT_DETAILS = {
  ship: {
    displayName: "Galfi Ship",
    address: "0xa347d4c65cbbc05ba574c937bf96e8a1156de3e9",
    symbol: "GALFISHIP",
    handle: "SHIP",
    type: "ship",
    collectionID: "667e91c21ea449904060390a",
  },
  planet: {
    displayName: "Galfi Planet",
    address: "0x89a86bb78e128fc59effd0417f5bcee62627a9bd",
    symbol: "GALFIPLANET",
    handle: "PLANET",
    type: "planet",
  },
  specialcrew: {
    displayName: "Galfi Special Crew",
    address: "0x1ab9c51db5b5b15295c2ef138586dc774235c909",
    symbol: "GALFISPECIALCREW",
    handle: "SPECIALCREW",
    type: "crew",
  },
  astroid: {
    displayName: "Galfi Asteroid",
    address: "0xc9cf4a8ec505c9fc3f00b989b0d5c5f61d5abe5e",
    symbol: "GALFIASTROID",
    handle: "ASTROID",
    type: "astroid",
  },
  crew: {
    displayName: "Galfi Crew",
    address: "0x665b8a0467a8f78dc78ea4e88b8592df5f3984ca",
    symbol: "GALFICREW",
    handle: "CREW",
    type: "crew",
  },
};

if (EnvName === "demo") {
  console.log(EnvName, " config running................");
  key.adminaddress = "0xEA4fE72960C36CA7a9F4E6A107fDfE07a952704E".toLowerCase();
  // key.adminaddress = '0xEA4fE72960C36CA7a9F4E6A107fDfE07a952704E'.toLowerCase()
  key.FRONT_URL = "https://galfi-nftmarktplace-frontend.pages.dev";
  key.BACK_URL = "https://backend-galfi.maticz.in/v1";
  key.ADMIN_URL = "https://backend-galfi.maticz.in/v1/admin";
  // key.IMG_URL = 'https://backend-galfi.maticz.in'
  key.chain_Id_List = [97, 43113];
  key.DEADADDRESS = "0x000000000000000000000000000000000000dEaD".toLowerCase();
  key.TradeContract =
    "0xEF747c5efE5e0eb67DCC06896341dfb9DF5f4F29".toLowerCase();
  key.erc20Address = "0x7CAB80ce0E55F46378E493B584eE61aD68878f11".toLowerCase();
  // key.RPC_URL = "https://bsc-testnet-rpc.publicnode.com";
  key.RPC_URL = "https://sepolia.infura.io/v3/6bcc2d2f4a6e45de849563164d80ca26";

  key.CHAIN_ID = 11155111;
  key.chain_Id_List = [11155111, 43113];
  key.Block_URL = "https://testnet.bscscan.com";
  key.COIN_NAME = "BNB";
  key.BNBCHAIN = 11155111;
  key.ETHCHAIN = 11155111;
  key.COIN_ARRAY = ["sepolia", "eth", "bnb", "matic"];
  key.COLLECTION = DEMO_COLLECTION_CONTRACT_DETAILS;
}

if (EnvName === "local") {
  console.log(EnvName, " config running................");
  key.FRONT_URL = "http://localhost:3000/phoneixai";
  key.BACK_URL = "http://localhost:4000/v1";
  key.ADMIN_URL = "http://localhost:4000/v1/admin";
  // key.IMG_URL = 'http://localhost:4000'
  key.DefaultImg = "/assets/images/avatar/avatar-01.png";
  key.CoverImg = "http://localhost:3330/demobanner.jpg";
  key.DEADADDRESS = "0x000000000000000000000000000000000000dEaD".toLowerCase();
  key.TradeContract =
    "0x54677298c49d19a2335aEf2B32ae3d643f9ccf1B".toLowerCase();
  key.ERC1155 = "0x708390Ff3f96F4F46761319E07c50f0DADC22E66".toLowerCase();
  key.erc20Address = "0xc6aBa068A91d327B259327523f71f51221943186".toLowerCase(); 
  // key.erc20Address = '0x7CAB80ce0E55F46378E493B584eE61aD68878f11'.toLowerCase()
  // key.RPC_URL = "https://bsc-testnet-rpc.publicnode.com"
  // key.RPC_URL = "https://sepolia.drpc.org/";
  key.RPC_URL = "https://sepolia.infura.io/v3/6bcc2d2f4a6e45de849563164d80ca26";

  key.CHAIN_ID = 11155111;
  key.chain_Id_List = [11155111, 97];
  key.Block_URL = "https://testnet.bscscan.com";
  key.COIN_NAME = "sepolia";
  key.BNBCHAIN = 11155111;
  key.ETHCHAIN = 11155111;
  key.COIN_ARRAY = ["sepolia", "eth", "bnb", "matic"];
  key.COLLECTION = DEMO_COLLECTION_CONTRACT_DETAILS;
}

if (EnvName === "stage") {
  console.log(EnvName, " config running................");
  key.adminaddress = "0x5c985839aC19164D9386E21C4d8a3857d0934c7a".toLowerCase();//not used
  key.FRONT_URL = "https://nft-stage.galfi.io/";
  key.BACK_URL = "https://uat-backend.galfi.io/v1";
  key.ADMIN_URL = "https://uat-backend.galfi.io/v1/admin";
  key.CoverImg = "https://uat-backend.galfi.io/demobanner.jpg";
  key.DefaultImg = "/assets/images/avatar/avatar-01.png";
  key.chain_Id_List = [11155111];
  // key.chain_Id_List = [97, 43113];
  key.DEADADDRESS = "0x000000000000000000000000000000000000dEaD".toLowerCase();
  key.TradeContract =
    "0xb7765862A5ce4fc48AABBCcd2d0660D6330a6216".toLowerCase();

  key.erc20Address = "0x7CAB80ce0E55F46378E493B584eE61aD68878f11".toLowerCase();//not used
  key.RPC_URL = "https://sepolia.infura.io/v3/6bcc2d2f4a6e45de849563164d80ca26";
  key.CHAIN_ID = 11155111;
  key.Block_URL = "https://sepolia.etherscan.io";
  key.COIN_NAME = "BNB";
  key.BNBCHAIN = 11155111;
  key.ETHCHAIN = 11155111;
  key.COIN_ARRAY = ["sepolia", "eth", "bnb", "matic"];
  key.COLLECTION = PRODUCTION_COLLECTION_CONTRACT_DETAILS;
}

export default key;
